import { ElementProps } from "../../../types/common";

export const ShareIcon = (props: ElementProps) => (
  <svg
    width={20}
    height={17}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 4.914V.586l4.707 4.707 3.773 3.774-3.84 3.2L11 16.136V11.9C2.852 11.286 0 16 0 16c0-2.937.241-5.985 2.55-8.293C5.234 5.022 9.121 4.832 11 4.914Z"
      fill="#22282B"
    />
  </svg>
);
